import { supabase } from '../lib/supabase';

/**
 * Save a contract to Supabase and return the generated UUID
 */
export const saveContract = async ({ contractTitle, contractText }) => {
  const { data, error } = await supabase?.from('contracts')?.insert({
      contract_title: contractTitle,
      contract_text: contractText,
    })?.select('id')?.single();

  if (error) {
    console.error('Error saving contract:', error);
    throw error;
  }

  return data?.id;
};

/**
 * Fetch a contract by UUID
 */
export const fetchContractById = async (id) => {
  const { data, error } = await supabase?.from('contracts')?.select('id, contract_title, contract_text, created_at')?.eq('id', id)?.single();

  if (error) {
    console.error('Error fetching contract:', error);
    throw error;
  }

  return {
    id: data?.id,
    contractTitle: data?.contract_title,
    contractText: data?.contract_text,
    createdAt: data?.created_at,
  };
};
